import { HashRouter, Routes, Route } from "react-router-dom"
import { useState, useEffect } from "react"
import Home from "./pages/Home"
import SampleQuiz from "./pages/SampleQuiz"
import PrivacyPolicy from "./pages/PrivacyPolicy"
import TermsOfUse from "./pages/TermsOfUse"
import Contact from "./pages/Contact"
import RefundRequest from "./pages/RefundRequest"
import NotFound from "./pages/NotFound"

const EU_COUNTRIES = [
    "AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR",
    "DE","GR","HU","IE","IT","LV","LT","LU","MT","NL",
    "PL","PT","RO","SK","SI","ES","SE",
]


function RegionBlocked() {
    return (
        <div style={{
            minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
            fontFamily: "Inter, sans-serif", background: "#F9FAFB", padding: 24,
        }}>
            <div style={{
                maxWidth: 480, textAlign: "center",
                border: "1px solid #E5E7EB", borderRadius: 20,
                padding: "48px 40px", background: "white",
                boxShadow: "0 10px 30px rgba(17,24,39,0.05)",
            }}>
                <div style={{ fontSize: 40, marginBottom: 16 }}>🌍</div>
                <h1 style={{ fontSize: 24, fontWeight: 800, color: "#111827", margin: "0 0 12px", letterSpacing: "-0.03em" }}>
                    Not Available in Your Region
                </h1>
                <p style={{ fontSize: 15, color: "#6B7280", lineHeight: 1.7, margin: "0 0 16px" }}>
                    Qwiztime is currently available in the <strong style={{ color: "#111827" }}>United States only</strong>.
                    We are working to expand our service in the future.
                </p>
                <p style={{ fontSize: 13, color: "#9CA3AF", lineHeight: 1.6, margin: 0 }}>
                    If you are in the US and seeing this message, please disable your VPN and refresh the page.
                </p>
            </div>
        </div>
    )
}

export default function App() {
    const [geoStatus, setGeoStatus] = useState("checking") // "checking" | "allowed" | "blocked"

    useEffect(() => {
        fetch("https://ip-api.com/json/?fields=countryCode")
            .then(r => r.json())
            .then(d => {
                setGeoStatus(EU_COUNTRIES.includes(d.countryCode) ? "blocked" : "allowed")
            })
            .catch(() => setGeoStatus("allowed")) // fail open — don't block on API error
    }, [])

    if (geoStatus === "checking") return null
    if (geoStatus === "blocked")  return <RegionBlocked />

    return (
        <HashRouter>
            <Routes>
                <Route path="/"                 element={<Home />} />
                <Route path="/sample/:quizId"   element={<SampleQuiz />} />
                <Route path="/privacy"          element={<PrivacyPolicy />} />
                <Route path="/terms"            element={<TermsOfUse />} />
                <Route path="/contact"          element={<Contact />} />
                <Route path="/refund"           element={<RefundRequest />} />
                <Route path="*"                 element={<NotFound />} />
            </Routes>
        </HashRouter>
    )
}
